import { createReducer } from '@reduxjs/toolkit';

import { PushType } from '../../types';
import { clearPush, setPush } from '../actions/app';

const initialState: PushType = {
  push: {
    message: '',
    type: 'default',
  },
};

const appReducer = createReducer(initialState, (builder) => {
  builder.addCase(setPush, (state, action) => {
    state.push = action.payload;
  });

  builder.addCase(clearPush, (state, _) => {
    state.push = initialState.push;
  });
});

export default appReducer;
